/* global lightGallery */
import 'lightgallery.js';

// Light gallery submodules: remove one or more to disable
import 'lg-thumbnail.js';
import 'lg-autoplay.js';
import 'lg-video.js';
import 'lg-fullscreen.js';
import 'lg-pager.js';
import 'lg-zoom.js';
import 'lg-hash.js';
import 'lg-share.js';

class LightGallery {
  constructor(options = {}) {
    this.config = {
      moduleList: document.querySelectorAll('[data-module="LightGallery"]'),
      ...options
    };
  }

  init() {
    const { moduleList } = this.config;

    moduleList.forEach(module => {
      lightGallery(module, {
        actualSize: false,
        autoplayControls: false,
        download: false,
        fullScreen: false,
        selector: '.js-lightgallery-item',
        share: false,
        showThumbByDefault: false
      });
    });
  }
}

export default LightGallery;
